import Logo from "../assets/cloverbay-logo-loader.png";
const Loader = () => (
  <div className="logo-loader">
    <img src={Logo} alt="loading" />
  </div>
);
export default Loader;
